module.exports = __webpack_public_path__ + "static/elempanel1-961530c7c12b633f326bc22581a6b602.png";